export default __webpack_public_path__ + "static/media/when_it_rains.058269cd.JPG";